<template>
  <div class="check-box">
    <input :name="rName" :id="rId" class="check-input" type="checkbox"/>
    <label :for="rId" class="label-btn" @click="toggleFn">
      <i class="icon" :class="checkboxFlag ? 'icon-checkbox-checked' : 'icon-checkbox-unchecked'"></i>
    </label>
    <!--<i class="icon-checkmark" v-show="checkboxFlag"></i>-->
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    name: 'radio',
    props: {
      mold: {
        type: String
      },
      rId: {
        type: String,
        default: ''
      },
      rName: {
        tpye: String,
        default: ''
      }
    },
    data () {
      return {
        checkboxFlag: false
      }
    },
    methods: {
      // 单选切换
      toggleFn () {
        // 切换单选框状态
        this.checkboxFlag = !this.checkboxFlag
        // 将复选框的值传递到父级
        this.$emit('checkboxEv', this.rName, this.checkboxFlag)
        // 如果是创建服务器密码的调用
        /* if (this.mold === 'serverPwd') {
          // 将修改后的状态提交到 store
          this.$store.commit('setFlag', this.checkboxFlag)
        } */
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "checkboxComponent.styl";
</style>



// WEBPACK FOOTER //
// src/components/checkboxComponent/checkboxComponent.vue